
interface FAQItem {
  question: string
  answer: string
}

const faqData: FAQItem[] = [
  {
    question: 'What is Chrysalis Investment Strategy?',
    answer: 'Chrysalis hatches investing insights for its partners by analyzing proprietary data from the bitcoin market.'
  },
  {
    question: 'Can you really beat "the market" in the short term?',
    answer: 'The short-term market is a voting machine dominated by institutions who have effectively infinite liquidity and infinite resources. Individuals with laptops and a small portfolio cannot compete and to think otherwise would be foolish.'
  },
  {
    question: 'Can you really beat "the market" in the long term?',
    answer: 'The long-term market performance is about 12% per year. This is easy to beat in the short term but hard to maintain in the long term since it requires constant attention and active management, which is why people generally opt to use index funds, which gives that return with compounding and requires no maintenance ever at the cost of meaningful returns.'
  },
  {
    question: 'So why bother? Why not just invest in the total stock market index?',
    answer: 'The long-term performance of the total stock market index is not a attributable to the companies of the economy creating more value but rather a function of the growth in the monetary supply. Unfortuantely that means that index funds will merely preserve an investor\'s purchasing power over the course of time even though the nominal value grows at around 10-12% per year. For people who are content with average returns, who value safety over increasing their purchasing power, index funds are a good option. Investors who value returns over safety should consider moving out on the risk spectrum, into Bitcoin and similar assets.'
  },
  {
    question: 'Where is Chrysalis\' edge?',
    answer: 'Chrysalis\' edge comes from three things: 1) investing in the medium term: which is the weeks and months timeframe, 2) the ability to use proprietary market data to make informed decisions, and 3) focusing on instruments like Bitcoin, which have higher volatility and thus inherent potential for greater returns.'
  },
  {
    question: 'Surely you don\'t actually have private market data? Everything asset markets do is public...',
    answer: 'Everything is public but not everything is recorded. Chrysalis uses data that is public but not stored anywhere. We store it and thus what is public today is proprietary tomorrow. Techncially, if someone were to reverse-engineer our strategy, they might also be able to figure out how to derive our proprietary data from past public data but this is unlikely to happen. Since we focus on the medium and long terms, yesterday\'s data isn\'t "stale" for the purposes of our analysis.'
  },
  {
    question: 'Can you open source your strategy?',
    answer: 'We\'re not ready to open source our strategy yet, but maybe will eventually. Contact the author if interested in collaborating on X @lantisDan or by joining the Crypto Lab Discord at https://discord.gg/abVtmxQxzA.'
  }
]

export default faqData

